var kindOf = require('./kindOf');
    /**
     * Check if value is from a specific "kind".
     */
    function isKind(val, kind){
        return kindOf(val) === kind;
    }
    module.exports = isKind;




//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/lang/isKind.js
// module id = 156
// module chunks = 1